import { AnimatePresence, motion } from 'framer-motion';
import { Box, Stack, Typography } from '@mui/material';
import React, { useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { navbarMenu } from 'src/resources/data/landingPageData';

const NavbarMenu: React.FC = () => {
    const [open, setOpen] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const navigate = useNavigate();
    const location = useLocation();

    const handleOpen = (_event: React.MouseEvent<HTMLElement>) => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        setOpen(true);
    };

    const handleClose = () => {
        timeoutRef.current = setTimeout(() => {
            setOpen(false);
        }, 150); // delay to allow mouse move into Menu
    };

    return (
        <Stack direction="row" width="50%" justifyContent="space-between">
            {navbarMenu.map((menuItem, index) =>
                menuItem.subMenu ? (
                    <Box
                        key={index}
                        onMouseEnter={handleOpen}
                        onMouseLeave={handleClose}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                color: location.pathname.includes(menuItem.link) ? "primary.main" : "primary.light",
                                ":hover": { color: "#ea728c" }
                            }}
                            onClick={() => navigate(menuItem.link)}
                        >
                            {menuItem.title}
                            <ExpandMoreIcon />
                        </Typography>

                        {/* Menu */}
                        <AnimatePresence>
                            {open && (
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: 10 }}
                                    transition={{ duration: 0.3, ease: 'easeOut' }}
                                    style={{ position: 'absolute', zIndex: 10 }}
                                >
                                    <Box
                                        sx={{
                                            bgcolor: 'white',
                                            color: 'black',
                                            mt: 2,
                                            p: 2,
                                            borderRadius: 1,
                                            boxShadow: 3,
                                        }}
                                    >
                                        {menuItem.subMenu.map((sub, i) => (
                                            <motion.div
                                                key={i}
                                                whileHover={{ y: -2 }} // Slight move up on hover
                                                transition={{ type: 'spring', stiffness: 300 }}
                                            >
                                                <Typography
                                                    sx={{
                                                        py: 0.5,
                                                        px: 1,
                                                        borderRadius: 1,
                                                        ":hover": {
                                                            color: "#ea728c",
                                                            cursor: "pointer",
                                                            bgcolor: "rgba(0,0,0,0.05)",
                                                        },
                                                    }}
                                                    onClick={()=> {
                                                        const subLink= sub.link !== undefined ? sub.link : "";
                                                        // TODO: Fix this navigation logic
                                                        navigate("/");
                                                        navigate(subLink);
                                                    }}
                                                >
                                                    {sub.title}
                                                </Typography>
                                            </motion.div>
                                        ))}
                                    </Box>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </Box>
                ) : (
                    <Typography
                        key={index}
                        variant="h6"
                        sx={{
                            cursor: 'pointer',
                            color: location.pathname === menuItem.link ? "primary.main" : "primary.light"
                        }}
                        onClick={() => navigate(menuItem.link)}
                    >
                        {menuItem.title}
                    </Typography>
                )
            )}
        </Stack>
    )
}

export default NavbarMenu